import { render, staticRenderFns } from "./TosModal.vue?vue&type=template&id=088b5ccb&"
import script from "./TosModal.vue?vue&type=script&lang=js&"
export * from "./TosModal.vue?vue&type=script&lang=js&"
import style0 from "./TosModal.vue?vue&type=style&index=0&id=088b5ccb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports